import { Modal, ModalHeader, ModalBody, ModalFooter, MODAL_SIZES } from 'ui/modal';
import { useDispatch } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { DestructiveButton } from 'ui/button';
import { useModalsContext } from '../contexts';
import { removeIntegrationRequest } from '../actions';
import { ThirdPartyIntegration } from '../types';

export const DeleteThirdPartyIntegrationModal = () => {
  const dispatch = useDispatch();
  const { hideModal } = useModalsContext();

  const { formState } = useFormContext<ThirdPartyIntegration>();
  const { defaultValues: integration } = formState;

  const onDelete = () => {
    if (!integration) return;
    dispatch(removeIntegrationRequest(integration?.id, integration.analyticsProvider));
    hideModal();
  };

  return !integration ? null : (
    <Modal
      id="deleteThirdPartyIntegrationModal"
      isModalOpen
      size={MODAL_SIZES.SMALL}
      onClose={hideModal}
    >
      <ModalHeader>Delete third party integration</ModalHeader>
      <ModalBody>
        Are you sure you would like to delete {integration.analyticsProvider} (Id: {integration.id}
        )?
      </ModalBody>
      <ModalFooter hasCancel onClose={hideModal}>
        <DestructiveButton data-test="delete-integration" onClick={onDelete}>
          Delete
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
